import { Select } from "antd";
import { MdArrowDropDown } from "react-icons/md";

const Budget = ({ options, value, onChange, translate }) => {
  return (
    <div className="miltis-budget">
      <span className="miltis-budget__title">
        {translate?.BUDGET?.TITLE ||
          "Quel est le budget mensuel que vous souhaitez consacrer à votre garantie ?"}
      </span>
      <Select
        placeholder={
          translate?.BUDGET?.PLACEHOLDER || "Sélectionnez un intervalle"
        }
        options={options}
        value={value}
        onChange={(e) => onChange(e)}
        className="miltis-budget__select"
        suffixIcon={<MdArrowDropDown className="miltis-budget__arrow" />}
        popupMatchSelectWidth={false}
      />
    </div>
  );
};

export default Budget;
